import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCopy = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 13,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group 14108",
		fill: "currentColor",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Rectangle 3403 (Stroke)",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M10 6.5H6V10.5H10V6.5ZM4 4.5V12.5H12V4.5H4Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Rectangle 3402",
				d: "M0 0.5H2V8.5H0V0.5Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Rectangle 3404",
				d: "M0 0.5H8V2.5H0V0.5Z",
				fill: "currentColor"
			})
		]
	})
});
export { SvgCopy as ReactComponent };
